import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";
import { useEffect, useState } from "react";

interface PasswordInputEyeProps {
  input: string,
  onChange: (newValue: string) => void,
  onEnterPressed: () => void
}

export default function PasswordInputEye({input, onChange, onEnterPressed}: PasswordInputEyeProps) {

  const [showPassword, setShowPassowrd] = useState(false);
  const [passwordInput, setPasswordInput] = useState(input);

  useEffect(() => {
    setPasswordInput(input);
  }, [input]);

  const toggleShowPassword = () => {
    setShowPassowrd(prev => !prev);
  }

  return(
    <div className={`flex relative w-6/7 max-w-80`}>
      <Input 
        type={`${showPassword ? "text" : "password"}`}
        className="w-full pr-10 focus:ring-0 border-2 bg-white/10 rounded-sm text-white text-xs font-gotham font-normal" 
        placeholder="Password"
        onChange={(e) => onChange(e.target.value)}
        value={input}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onEnterPressed();
          }
        }}
      />
      <div className="cursor-pointer absolute right-0 h-full px-4 flex justify-center items-center" onClick={toggleShowPassword}>
        {showPassword
          ? <EyeOff className="size-5 text-white"/>
          : <Eye className="size-5 text-white"/>
        }
      </div>
    </div>
  )

}